import { clamp } from '@/utils/number'
import TmLogicError from '@/core/error/tmLogicError'

export const formatPercentage = (done: number, total: number, fractionDigits: number = 2): string => {
  if (total === 0) {
    throw new TmLogicError('"total" value must not be 0')
  }

  const percentage = Number(((done / total) * 100).toFixed(fractionDigits))

  return `${clamp(percentage, 0, 100)}%`
}
